// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"2e12542e","223":"6a7ea1d5","453":"d855a71b","603":"12973eb6"}[chunkId] + ".chunk.js";
};